import clsx from 'clsx';

import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import styles from './inlineAlert.module.scss';

type InlineAlertProps = {
  children: string | React.ReactNode;
  className?: string;
};

export function InlineAlert({ children, className }: InlineAlertProps) {
  return (
    <div className={clsx(styles['alert'], className)}>
      <GoogleFontIcon className={styles['alert__icon']} name="report" solid />
      {children}
    </div>
  );
}
